import { delay, put, select, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import { API_URL } from "utils/constants";
import { getDefaultHeaders } from "utils/helpers";
import { request } from "utils/request";
import { selectForm } from "./selector";

function* getSupplierListSaga() {
  yield delay(300);
  try {
    const options = {
      method: "GET",
      headers: getDefaultHeaders(),
    };
    const response = yield request(`${API_URL}/vendor/list`, options);
    yield put(actions.getSupplierSuccess(response.data));
  } catch (error) {
    yield put(actions.getSupplierFailure());
  }
}

function* createSupplierSaga() {
  try {
    const form = yield select(selectForm);
    const options = {
      method: "POST",
      headers: getDefaultHeaders(),
      body: JSON.stringify(form),
    };
    const response = yield request(`${API_URL}/vendor`, options);
    yield put(actions.createSupplierSuccess(response.data));
  } catch (error) {
    yield put(actions.createSupplierFailure());
  }
}

export function* SuppliersSaga() {
  yield takeLatest(actions.getSupplierList.type, getSupplierListSaga);
  yield takeLatest(actions.craeteSupplier.type, createSupplierSaga);
}